export enum MunicipalityGT {
  'Amatitlan' = 1,
  'Chinautla' = 2,
  'Chuarrancho' = 3,
  'Fraijanes' = 4,
  'Guatemala' = 5,
  'Mixco' = 6,
  'Palencia' = 7,
  'San Jose del Golfo' = 8,
  'San Jose Pinula' = 9,
  'San Juan Sacatepequez' = 10,
  'San Miguel Petapa' = 11,
  'San Pedro Ayampuc' = 12,
  'San Pedro Sacatepequez' = 13,
  'San Raymundo' = 14,
  'Santa Catarina Pinula' = 15,
  'Villa Canales' = 16,
  'Villa Nueva' = 17,
  'El Jicaro' = 18,
  'Guastatoya' = 19,
  'Morazan' = 20,
  'San Agustin Acasaguastlan' = 21,
  'San Antonio la Paz' = 22,
  'San Cristobal Acasaguastlan' = 23,
  'Sanarate' = 24,
  'Sansare' = 25,
  'Alotenango' = 26,
  'Antigua Guatemala' = 27,
  'Ciudad Vieja' = 28,
  'Jocotenango' = 29,
  'Magdalena Milpas Altas' = 30,
  'Pastores' = 31,
  'San Antonio Aguas Calientes' = 32,
  'San Bartolome Milpas Altas' = 33,
  'San Lucas Sacatepequez' = 34,
  'San Miguel Duenas' = 35,
  'Santa Catarina Barahona' = 36,
  'Santa Lucia Milpas Altas' = 37,
  'Santa Maria De Jesus' = 38,
  'Santiago Sacatepequez' = 39,
  'Santo Domingo Xenacoj' = 40,
  'Sumpango' = 41,
  'Acatenango' = 42,
  'Chimaltenango' = 43,
  'Comalapa' = 44,
  'El Tejar' = 45,
  'Parramos' = 46,
  'Patzicia' = 47,
  'Patzun' = 48,
  'Pochuta' = 49,
  'San Andres Itzapa' = 50,
  'San Jose Poaquil' = 51,
  'San Martin Jilotepeque' = 52,
  'Santa Apolonia' = 53,
  'Santa Cruz Balanya' = 54,
  'Tecpan Guatemala' = 55,
  'Yepocapa' = 56,
  'Zaragoza' = 57,
  'Escuintla' = 58,
  'Guanagazapa' = 59,
  'Iztapa' = 60,
  'La Democracia' = 61,
  'La Gomera' = 62,
  'Masagua' = 63,
  'Nueva Concepcion' = 64,
  'Palin' = 65,
  'San Jose' = 66,
  'San Vicente Pacaya' = 67,
  'Santa Lucia Cotzumalguapa' = 68,
  'Sipacate' = 69,
  'Siquinala' = 70,
  'Tiquisate' = 71,
  'Barberena' = 72,
  'Casillas' = 73,
  'Chiquimulilla' = 74,
  'Cuilapa' = 75,
  'Guazacapan' = 76,
  'Nueva Santa Rosa' = 77,
  'Oratorio' = 78,
  'Pueblo Nuevo Vinas' = 79,
  'San Juan Tecuaco' = 80,
  'San Rafael las Flores' = 81,
  'Santa Cruz Naranjo' = 82,
  'Santa Maria Ixhuatan' = 83,
  'Santa Rosa de Lima' = 84,
  'Taxisco' = 85,
  'Concepcion' = 86,
  'Nahuala' = 87,
  'Panajachel' = 88,
  'San Andres Semetabaj' = 89,
  'San Antonio Palopo' = 90,
  'San Jose Chacaya' = 91,
  'San Juan La Laguna' = 92,
  'San Lucas Toliman' = 93,
  'San Marcos La Laguna' = 94,
  'San Pablo La Laguna' = 95,
  'San Pedro La Laguna' = 96,
  'Santa Catarina Ixtahuacan' = 97,
  'Santa Catarina Palopo' = 98,
  'Santa Clara La Laguna' = 99,
  'Santa Cruz La Laguna' = 100,
  'Santa Lucia Utatlan' = 101,
  'Santa Maria Visitacion' = 102,
  'Santiago Atitlan' = 103,
  'Solola' = 104,
  'Momostenango' = 105,
  'San Andres Xecul' = 106,
  'San Bartolo' = 107,
  'San Cristobal Totonicapan' = 108,
  'San Francisco El Alto' = 109,
  'Santa Lucia La Reforma' = 110,
  'Santa Maria Chiquimula' = 111,
  'Totonicapan' = 112,
  'Almolonga' = 113,
  'Cabrican' = 114,
  'Cajola' = 115,
  'Cantel' = 116,
  'Coatepeque' = 117,
  'Colomba' = 118,
  'Concepcion Chiquirichapa' = 119,
  'El Palmar' = 120,
  'Flores Costa Cuca' = 121,
  'Genova' = 122,
  'Huitan' = 123,
  'La Esperanza' = 124,
  'Olintepeque' = 125,
  'Palestina de Los Altos' = 126,
  'Quetzaltenango' = 127,
  'Salcaja' = 128,
  'San Carlos Sija' = 129,
  'San Francisco La Union' = 130,
  'San Juan Ostuncalco' = 131,
  'San Martin Sacatepequez' = 132,
  'San Mateo' = 133,
  'San Miguel Siguila' = 134,
  'Sibilia' = 135,
  'Zunil' = 136,

  'Chicacao' = 137,
  'Cuyotenango' = 138,
  'Mazatenango' = 139,
  'Patulul' = 140,
  'Pueblo Nuevo' = 141,
  'Rio Bravo' = 142,
  'Samayac' = 143,
  'San Antonio Suchitepequez' = 144,
  'San Bernardino' = 145,
  'San Francisco Zapotitlan' = 146,
  'San Gabriel' = 147,
  'San Jose El Idolo' = 148,
  'San Jose La Maquina' = 149,
  'San Juan Bautista' = 150,
  'San Lorenzo' = 151,
  'San Miguel Panan' = 152,
  'San Pablo Jocopilas' = 153,
  'Santa Barbara' = 154,
  'Santo Domingo Suchitepequez' = 155,
  'Santo Tomas La Union' = 156,
  'Zunilito' = 157,

  'Champerico' = 158,
  'El Asintal' = 159,
  'Nuevo San Carlos' = 160,
  'Retalhuleu' = 161,
  'San Andres Villa Seca' = 162,
  'San Felipe' = 163,
  'San Martin Zapotitlan' = 164,
  'San Sebastian' = 165,
  'Santa Cruz Mulua' = 166,

  'Ayutla' = 167,
  'Catarina' = 168,
  'Comitancillo' = 169,
  'Concepcion Tutuapa' = 170,
  'El Quetzal' = 171,
  'El Rodeo' = 172,
  'El Tumbador' = 173,
  'Esquipulas Palo Gordo' = 174,
  'Ixchiguan' = 175,
  'La Blanca' = 176,
  'La Reforma' = 177,
  'Malacatan' = 178,
  'Nuevo Progreso' = 179,
  'Ocos' = 180,
  'Pajapita' = 181,
  'Rio Blanco' = 182,
  'San Antonio Sacatepequez' = 183,
  'San Cristobal Cucho' = 184,
  'San Jose Ojetenan' = 185,
  'San Lorenzo ' = 186,
  'San Marcos' = 187,
  'San Miguel Ixtahuacan' = 188,
  'San Pablo' = 189,
  'San Pedro Sacatepequez ' = 190,
  'San Rafael Pie de la Cuesta' = 191,
  'Sibinal' = 192,
  'Sipacapa' = 193,
  'Tacana' = 194,
  'Tajumulco' = 195,
  'Tejutla' = 196,

  'Aguacatan' = 197,
  'Barillas' = 198,
  'Chiantla' = 199,
  'Colotenango' = 200,
  'Concepcion ' = 201,
  'Cuilco' = 202,
  'Huehuetenango' = 203,
  'Ixtahuacan' = 204,
  'Jacaltenango' = 205,
  'La Democracia ' = 206,
  'La Libertad' = 207,
  'Malacatancito' = 208,
  'Nenton' = 209,
  'Petatan' = 210,
  'San Antonio Huista' = 211,
  'San Gaspar Ixchil' = 212,
  'San Juan Atitan' = 213,
  'San Juan Ixcoy' = 214,
  'San Mateo Ixtatan' = 215,
  'San Miguel Acatan' = 216,
  'San Pedro Necta' = 217,
  'San Rafael Independencia' = 218,
  'San Rafael Petzal' = 219,
  'San Sebastian Coatan' = 220,
  'San Sebastian Huehuetenango' = 221,
  'Santa Ana Huista' = 222,
  'Santa Barbara ' = 223,
  'Santa Eulalia' = 224,
  'Santiago Chimaltenango' = 225,
  'Soloma' = 226,
  'Tectitan' = 227,
  'Todos Santos Cuchumatan' = 228,
  'Union Cantinil' = 229,

  'Canilla' = 230,
  'Chajul' = 231,
  'Chicaman' = 232,
  'Chiche' = 233,
  'Chichicastenango' = 234,
  'Chinique' = 235,
  'Cunen' = 236,
  'Ixcan' = 237,
  'Joyabaj' = 238,
  'Nebaj' = 239,
  'Pachalum' = 240,
  'Patzite' = 241,
  'Sacapulas' = 242,
  'San Andres Sajcabaja' = 243,
  'San Antonio Ilotenango' = 244,
  'San Bartolome Jocotenango' = 245,
  'San Juan Cotzal' = 246,
  'San Pedro Jocopilas' = 247,
  'Santa Cruz del Quiche' = 248,
  'Uspantan' = 249,
  'Zacualpa' = 250,

  'Cubulco' = 251,
  'El Chol' = 252,
  'Granados' = 253,
  'Purulha' = 254,
  'Rabinal' = 255,
  'Salama' = 256,
  'San Jeronimo' = 257,
  'San Miguel Chicaj' = 258,

  'Cahabon' = 259,
  'Chahal' = 260,
  'Chisec' = 261,
  'Coban' = 262,
  'Fray Bartolome de las Casas' = 263,
  'Lanquin' = 264,
  'Panzos' = 265,
  'Raxruha' = 266,
  'San Cristobal Verapaz' = 267,
  'San Juan Chamelco' = 268,
  'San Pedro Carcha' = 269,
  'Santa Catalina La Tinta' = 270,
  'Santa Cruz Verapaz' = 271,
  'Senahu' = 272,
  'Tactic' = 273,
  'Tamahu' = 274,
  'Tucuru' = 275,

  'Dolores' = 276,
  'El Chal' = 277,
  'Flores' = 278,
  'La Libertad ' = 279,
  'Las Cruces' = 280,
  'Melchor de Mencos' = 281,
  'Poptun' = 282,
  'San Andres' = 283,
  'San Benito' = 284,
  'San Francisco' = 285,
  'San Jose ' = 286,
  'San Luis' = 287,
  'Santa Ana' = 288,
  'Sayaxche' = 289,

  'El Estor' = 290,
  'Livingston' = 291,
  'Los Amates' = 292,
  'Morales' = 293,
  'Puerto Barrios' = 294,

  'Cabanas' = 295,
  'Estanzuela' = 296,
  'Gualan' = 297,
  'Huite' = 298,
  'La Union' = 299,
  'Rio Hondo' = 300,
  'San Diego' = 301,
  'San Jorge' = 302,
  'Teculutan' = 303,
  'Usumatlan' = 304,
  'Zacapa' = 305,

  'Camotan' = 306,
  'Chiquimula' = 307,
  'Concepcion Las Minas' = 308,
  'Esquipulas' = 309,
  'Ipala' = 310,
  'Jocotan' = 311,
  'Olopa' = 312,
  'Quezaltepeque' = 313,
  'San Jacinto' = 314,
  'San Jose La Arada' = 315,
  'San Juan Ermita' = 316,

  'Jalapa' = 317,
  'Mataquescuintla' = 318,
  'Monjas' = 319,
  'San Carlos Alzatate' = 320,
  'San Luis Jilotepeque' = 321,
  'San Manuel Chaparron' = 322,
  'San Pedro Pinula' = 323,

  'Agua Blanca' = 324,
  'Asuncion Mita' = 325,
  'Atescatempa' = 326,
  'Comapa' = 327,
  'Conguaco' = 328,
  'El Adelanto' = 329,
  'El Progreso' = 330,
  'Jalpatagua' = 331,
  'Jerez' = 332,
  'Jutiapa' = 333,
  'Moyuta' = 334,
  'Pasaco' = 335,
  'Quezada' = 336,
  'SanJoseAcatempa' = 337,
  'Santa Catarina Mita' = 338,
  'Yupiltepeque' = 339,
  'Zapotitlan' = 340
}
